import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {};

export default new Vuex.Store({
  state,
});
// import Vue from "vue";
// import Vuex from "vuex";

// Vue.use(Vuex);

// export default new Vuex.Store({
//   state: {
//     navIndex: 0,
//     menuName: "",
//   },
//   mutations: {
//     updateNav(state, data) {
//       state.navIndex = data.navIndex;
//       state.menuName = data.menuName;
//     },
//   },
//   actions: {
//     // 触发 navClick 的行为，同时更新 Vuex 状态
//     updateNavData({ commit }, data) {
//       commit("updateNav", data);
//     },
//   },
// });
// import Vue from "vue";
// import Vuex from "vuex";

// Vue.use(Vuex);

// const store = new Vuex.Store({
//   state: {
//     navIndex: 0,
//     menuName: "",
//     isHomePage: false,
//     backgroundImage: "",
//   },
//   mutations: {
//     SET_NAV(state, { index, name }) {
//       state.navIndex = index;
//       state.menuName = name;
//       state.isHomePage = index === 0;

//       sessionStorage.setItem("navIndex", index);

//       if (state.isHomePage) {
//         state.backgroundImage = `url(${require("@/assets/img/backgroundHome1.png")})`;
//       } else if (index === 1) {
//         state.isHomePage = false;
//         state.backgroundImage = `url(${require("@/assets/img/background2.png")})`;
//       } else if (index === 2) {
//         if (name === "产品案例") {
//           return;
//         }
//         state.isHomePage = false;
//         let backgroundNumber =
//           name === "虚拟仿真" ? 3 : name === "智慧平台" ? 5 : 7;
//         state.backgroundImage = `url(${require("@/assets/img/background" +
//           backgroundNumber +
//           ".png")})`;
//       } else if (index === 3) {
//         state.isHomePage = false;
//         state.backgroundImage = `url(${require("@/assets/img/background4.png")})`;
//       }
//     },
//     // ... 其它 mutations
//   },
//   actions: {
//     updateNav({ commit }, { index, name }) {
//       commit("SET_NAV", { index, name });
//       // You might want to handle the interval set-up or other operations here
//     },
//     // ... 其它 actions
//   },
// });

// export default store;



// WEBPACK FOOTER //
// ./src/store/index.js